<template>
    <div :class="`text-${field.textAlign}`">
        <span v-if="field.value" class="whitespace-nowrap" dir="ltr">{{ fieldValue }}</span>
        <span v-else>&mdash;</span>
    </div>
</template>

<script>
export default {
    props: ['resourceName', 'field'],

    computed: {
        fieldValue() {
            if (this.field.usesCustomizedDisplay) {
                return this.field.displayedAs
            }

            return this.field.value
        },
    },
}
</script>
